module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pink_bg"
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n    page_0040_certificate_software_detail_bulk_edit\n  ")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "証書情報(一括編集）"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "25%",
      "float": "left",
      "margin-left": "-25px",
      "min-width": "100px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("\n          ＜　戻る\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("\n          更新日：" + _vm._s(_vm.registrationDate) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("\n          登録日：" + _vm._s(_vm.registrationDate) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n      承認状態：\n      "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "90px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": _vm.approvalStatus
    }
  }), _vm._v("\n      状態:\n      "), _c('select', {
    staticClass: "status_field",
    style: (_vm.statusFieldStyle),
    attrs: {
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": _vm.Status
    },
    on: {
      "change": function($event) {
        _vm.Status = $event.target.value
      }
    }
  }, _vm._l((_vm.StatusOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "selected": option == _vm.Status,
        "value": option
      }
    }, [_vm._v("\n          " + _vm._s(option) + "\n        ")])
  })), _vm._v("\n      申請No：\n      "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "140px",
      "padding-left": "4px",
      "margin": "2px",
      "margin-bottom": "-6px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px",
      "color": "#008cff",
      "text-decoration": "underline"
    },
    attrs: {
      "type": "button",
      "value": _vm.approvalHistoryTorokuNumber
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disableApplicationBtn == true),
      expression: "disableApplicationBtn == true"
    }],
    staticClass: "btn btn-primary on_confirm_execute_process_btn",
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onConfirmExecuteProcess
    }
  }, [_vm._v("\n        申請\n      ")]), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminSavingApplication == false || true),
      expression: "isAdminSavingApplication == false || true"
    }],
    staticClass: "btn btn-primary on_local_save_certificate_software",
    attrs: {
      "disabled": _vm.disableAllButtons ||
        _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onLocalSaveBulkCertificateSoftware
    }
  }, [_vm._v("\n        下書保存\n      ")]) : _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px"
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")])])], 1), _vm._v(" "), _c('certificate-information-connection-application-modal', {
    attrs: {
      "tag": "showBulkImportConfimationModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmUnlinkDevices"
    },
    on: {
      "done": _vm.onConfirmUnlinkDevices
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "onLocalSaveCertificateSoftwareAfterValudateStatusCheck"
    },
    on: {
      "done": _vm.onDeviceEmbeddedInformationAddCheckConfirmStep2
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "notificationCertificcateBulkAfterSave"
    },
    on: {
      "done": _vm.afterTheNotificationAfterSave
    }
  }), _vm._v(" "), _c('application-confirmation-modal', {
    attrs: {
      "tag": "certificateBulkApplicationConfimationModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteCertificateInformationDetailModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0px",
      "margin": "-15px"
    }
  }, [_c('h3', [_vm._v("ソフトウェア情報")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b4a4cdc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0040_certificate_software_detail_bulk_edit.vue
// module id = 1037
// module chunks = 0